exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topnav {\n  overflow: hidden;\n  padding-left: 24%;\n  padding-right: 15%;\n  float: right;\n}\n.bottomnav,\n.bottom {\n  overflow: hidden;\n  background-color: aliceblue;\n}\n.topnav a,\n.bottomnav a {\n  float: left;\n  text-align: center;\n  padding: 16px 16px;\n  text-decoration: none;\n  font-size: 16px;\n  color: white;\n}\n.bottomnav a {\n  color: #333;\n}\n.col-md-2 a {\n  color: white;\n}\n.topnav a:hover {\n  background-color: transparent;\n}\n#main-img {\n  width: 40%;\n  margin-left: 2em;\n}\n.row {\n  padding-top: 1em;\n  padding-bottom: 1em;\n  margin-right: 0;\n  padding-right: 0;\n}\n.wrapper {\n  background-color: #333;\n  margin-bottom: 1em;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/skye/Projects/Epicodus Projects/JavaScript/mock-mint/src/app/privatenav/privatenav.component.css
// module id = ../../../../../src/app/privatenav/privatenav.component.css
// module chunks = main